import { useContext } from 'react';
import { ToastContext } from './ToastContext';
import { ToastCreator } from './useToastCreator';

export function useToast(): ToastCreator {
  const { toast } = useContext(ToastContext);
  if (toast) {
    return toast;
  } else {
    throw new Error('useToast must be used within a ToastProvider');
  }
}
